import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { isMobile } from 'react-device-detect';
import CardImage from './Card';

interface ShowCardsOptionsProps {
    cards: string[];
    isMuckEnabled: boolean;
    onOptionSelect: (cards: string[]) => void;
    container?: HTMLElement | null;
}

const ShowCardsOptions: React.FC<ShowCardsOptionsProps> = ({
    cards,
    isMuckEnabled,
    onOptionSelect,
    container
}) => {
    if (!cards || cards.length < 2) {
        return null;
    }

    const renderCardLabel = (cardCodes: string[]) => (
        <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '6px',
            color: '#fff',
            fontSize: '14px',
            fontWeight: '500'
        }}>
            <span>Show</span>
            {cardCodes.map((card, index) => (
                <Box 
                    key={card} 
                    sx={{ 
                        display: 'inline-flex',
                        alignItems: 'center',
                        backgroundColor: '#ffffff',
                        padding: '2px',
                        borderRadius: '2px',
                        border: '1px solid #000000',
                    }}
                >
                    <CardImage card={card} micro />
                </Box>
            ))}
        </Box>
    );

    const buttonStyle = {
        minWidth: 'auto',
        padding: '8px 20px',
        height: '38px',
        fontSize: '14px',
        fontWeight: '500',
        textTransform: 'none',
        boxShadow: 'none',
        backgroundColor: 'rgba(20,21,26,0.9)',
        border: '1px solid rgba(255,255,255,0.3)',
        '&:hover': {
            backgroundColor: 'rgba(30,31,36,0.9)',
            border: '1px solid rgba(255,255,255,0.5)',
        }
    };

    return (
        <Box sx={{
            position: 'fixed',
            bottom: isMobile ? '50px' : '5px',
            right: isMobile ? '50px' : '500px',
            zIndex: 100000
        }}>
            <Stack 
                direction="column"
                spacing={1}
                sx={{ 
                    padding: '10px'
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => onOptionSelect([cards[0]])}
                    sx={buttonStyle}
                >
                    {renderCardLabel([cards[0]])}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => onOptionSelect([cards[1]])}
                    sx={buttonStyle}
                >
                    {renderCardLabel([cards[1]])}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => onOptionSelect(cards)}
                    sx={buttonStyle}
                >
                    {renderCardLabel(cards)}
                </Button>
            </Stack>
        </Box>
    );
};

export default ShowCardsOptions;